import { Link } from 'react-router-dom';

/**
 * Sections of one screen (Settings, People) as a row of links, so each has its
 * own address, the browser's back button works, and a screen reader hears which
 * one is current.
 */
export function SectionTabs(props: {
  label: string;
  tabs: { key: string; label: string }[];
  current: string;
  /** The address of a tab, e.g. `/settings?tab=xero`. */
  to(key: string): string;
}) {
  return (
    <nav className="sections" aria-label={props.label}>
      {props.tabs.map((t) => (
        <Link
          key={t.key}
          to={props.to(t.key)}
          aria-current={t.key === props.current ? 'page' : undefined}
          className={t.key === props.current ? 'on' : undefined}
        >
          {t.label}
        </Link>
      ))}
    </nav>
  );
}
